import React, { Component } from 'react';
import './HandLimitModal.css';

class HandLimitModal extends Component {

    render() {
        return (
            <div id="HandLimitModal" className="modal fade" data-backdrop="static" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog HandLimit_ModalDialog" role="document">
                    <div className="modal-content HandLimit_content">
                        <div className="HandLimitModalWrapper">
                            <img className="HandLimitImage"  src={this.props.baseUrlImg + "/images/MyHands/newFeature.gif"} alt="HandLimitGIF"></img>
                            <div className="HandLimitTitle">
                            {this.props.i18next.t("lable.maximum20Hands")}
                            </div>
                            <div className="HandLimitDescription">
                            {this.props.i18next.t("lable.youSelected")} {this.props.selectedHandCount} {this.props.i18next.t("lable.maximum20HandsReplayed")}</div>
                            <div className="HandLimitBtn" data-e2e="handsLimit" data-dismiss="modal" onClick={()=>{
                                this.props.selectTop20Hands();
                            }}>
                                {this.props.i18next.t("lable.selectdTop20Hands")}
                            </div>
                            <div className="HandLimitBtn HandLimitCloseBtn" data-dismiss="modal" data-e2e="close">
                            {this.props.i18next.t("lable.close")}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default HandLimitModal


/** WEBPACK FOOTER **
 ** ./src/components/HandHistory/HandLimitModal.js
 **/